import { createEpisodeComparisonChart } from './episode_comparison_chart';
import { wireEpisodeComparisonControls } from '../../date_pickers/episode_comparison_controls';

function episodeComparisonFactory() {
  return {
    chartApi: null,
    controlsApi: null,
    loading: false,
    lastSeries: [],
    init() {
      const chartEl = (this.$el && this.$el.querySelector) ? this.$el.querySelector('#chart-multiple') : document.getElementById('chart-multiple');
      if (!chartEl) return;
      const apiUrl = chartEl?.dataset?.apiUrl || '/analytics/chart';
      this.chartApi = createEpisodeComparisonChart(chartEl, apiUrl);

      const onChange = async ({ range, episodeIds }) => {
        this.loading = true;
        try {
          const { totals, series } = await this.chartApi.load(range, episodeIds);
          this.lastSeries = Array.isArray(series) ? series : [];
          this.buildTable(totals || []);
          this.updateEmptyMessages();
        } catch (e) {
          console.error('episode comparison reload error', e);
        } finally {
          this.loading = false;
        }
      };
      this.controlsApi = wireEpisodeComparisonControls(this.$el || document, onChange);

      // Initial render with current control state
      onChange({ range: this.controlsApi.getRange(), episodeIds: this.controlsApi.getEpisodeIds() });

      window.addEventListener('turbo:before-cache', () => this.destroy());
    },

    downloadCsv() {
      const seriesArr = this.lastSeries || [];
      if (!seriesArr.length) { return; }

      // Determine max number of days across all series
      const maxDays = seriesArr.reduce((max, s) => Math.max(max, Array.isArray(s.data) ? s.data.length : 0), 0);

      // Build header: Episode,Day 1,...,Day N
      const header = ["Episode"];
      for (let d = 0; d < maxDays; d++) header.push(`Day ${d + 1}`);

      function escapeCsv(val) {
        const s = val == null ? "" : String(val);
        const escaped = s.replace(/"/g, '""');
        if (/[",\n]/.test(s)) return `"${escaped}"`;
        return escaped;
      }

      const rows = [header];
      seriesArr.forEach(s => {
        const row = [s.name];
        const len = Array.isArray(s.data) ? s.data.length : 0;
        for (let i = 0; i < maxDays; i++) {
          const val = (i < len && s.data[i] != null) ? s.data[i] : 0;
          row.push(val);
        }
        rows.push(row);
      });

      const csvContent = rows.map(r => r.map(escapeCsv).join(",")).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "episode_comparison_downloads_transposed.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    buildTable(rows) {
      const table = this.$el.querySelector('#episode-comparison-table');
      if (!table) return;
      table.innerHTML = '';
      if (!rows || !rows.length) return;
      rows.forEach((r, i) => {
        const color = ['#5EBAB4', '#853ACF', '#D78846', '#1C7EBD', '#CF3A5F'][i % 5];
        table.innerHTML += `
          <tr>
            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
              <span class="rounded-full h-5 w-5 items-center justify-center mr-3" style="background-color: ${color}; padding: 0px 10px;"></span>${r.episode_number || ''}
            </td>
            <td class="px-3 py-4 text-sm text-gray-500">${r.name || ''}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">${r.total || 0}</td>
          </tr>`;
      });
    },

    updateEmptyMessages() {
      const noDataEl = this.$el.querySelector('#no-data-msg');
      const missingEl = this.$el.querySelector('#missing-date-msg');
      if (noDataEl) noDataEl.classList.add('hidden');
      if (missingEl) missingEl.classList.add('hidden');
    },

    destroy() {
      try { this.chartApi && this.chartApi.destroy && this.chartApi.destroy(); } catch (_) {}
      try { this.controlsApi && this.controlsApi.destroy && this.controlsApi.destroy(); } catch (_) {}
      this.chartApi = null;
      this.controlsApi = null;
    }
  };
}

try { window.EpisodeComparison = episodeComparisonFactory; } catch (_) {}
document.addEventListener('alpine:init', () => { try { Alpine.data('EpisodeComparison', episodeComparisonFactory); } catch (_) {} });
